export const ShareTabType = {
	EMAIL: 'EMAIL',
	FRIENDS: 'FRIENDS',
	GROUPS: 'GROUPS',
	LINK: 'LINK',
	POST: 'POST',
	SMS: 'SMS',
	USERS: 'USERS',
};
